<template>
  <b-container
    class="justify-content-start flex-wrap"
  >
    <div
      v-for="file in files"
      :key="file.id"
      class="my-card mx-md-3 mx-sm-1 text-center content-center"
    >
      <FileCard
        :selected-files="selectedFiles"
        :file="file"
        @select="selectFile"
        @open-folder="openFolder"
        @loading="loading"
      />
    </div>
  </b-container>
</template>

<script>
import {
  BContainer,
} from 'bootstrap-vue'
import FileCard from '@/layouts/components/FileCard.vue'

export default {
  name: 'FilesGrid',
  components: {
    FileCard,
    BContainer,

  },
  props: {
    files: {
      type: Array,
      required: true,
    },
    selectedFiles: {
      type: Array,
      default: () => [],
    },
  },
  methods: {

    log(msg) {
      console.log(msg)
    },
    openFolder(file) {
      this.$emit('open-folder', file)
    },
    selectFile(file) {
      this.$emit('select', file)
    },
    loading(show) {
      this.$emit('loading', show)
    },
  },
}
</script>

<style scoped>
.flex-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.my-card {
  width: 13rem;
}

.my-card-header {
  margin-left: auto;
  margin-right: auto;
  display: unset;
}
</style>
